// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.range-content {
  --background: linear-gradient(180deg, rgba(var(--ion-color-primary-rgb), 0.04), transparent 18%), var(--ion-background-color);
}

.range-shell {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.range-card {
  padding: 0.8rem;
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);
  border-radius: 18px;
  background: rgba(var(--ion-background-color-rgb), 0.98);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.range-card__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.7rem;
}

.range-card__top h2 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ion-text-color);
}

.range-card__top small {
  color: rgba(var(--ion-text-color-rgb), 0.58);
  font-size: 0.78rem;
}

.range-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.range-field-card {
  padding: 0.7rem;
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.07);
  border-radius: 14px;
  background: rgba(var(--ion-text-color-rgb), 0.02);
}

.range-field-card__label {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin-bottom: 0.45rem;
}

.range-field-card__label span {
  color: rgba(var(--ion-text-color-rgb), 0.56);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.range-field-card__label strong {
  color: var(--ion-text-color);
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1.3;
}

ion-item.range-field {
  --background: rgba(var(--ion-background-color-rgb), 0.92);
  --border-radius: 12px;
  --inner-padding-end: 0.35rem;
  --padding-start: 0.65rem;
  min-height: 2.75rem;
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);
}

ion-input.range-input {
  --padding-top: 0.55rem;
  --padding-bottom: 0.55rem;
  --padding-start: 0;
  --placeholder-color: rgba(var(--ion-text-color-rgb), 0.42);
  font-size: 0.92rem;
  font-weight: 600;
}

ion-datetime-button.range-trigger {
  display: block;
  margin-top: 0.45rem;
  min-height: 2.2rem;
}

.preset-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

ion-chip.preset-chip {
  margin: 0;
  min-height: 2rem;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.14);
  background: rgba(var(--ion-color-primary-rgb), 0.08);
  color: var(--ion-text-color);
  transition: background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
}

ion-chip.preset-chip.preset-chip--primary {
  border-color: rgba(var(--ion-color-primary-rgb), 0.18);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}

ion-chip.preset-chip.preset-chip--secondary {
  border-color: rgba(var(--ion-color-secondary-rgb), 0.18);
  background: rgba(var(--ion-color-secondary-rgb), 0.12);
}

ion-chip.preset-chip.preset-chip--active {
  border-color: rgba(var(--ion-color-primary-rgb), 0.42);
  background: rgba(var(--ion-color-primary-rgb), 0.2);
  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.24), 0 6px 14px rgba(var(--ion-color-primary-rgb), 0.14);
  transform: translateY(-1px);
}

ion-chip.preset-chip.preset-chip--secondary.preset-chip--active {
  border-color: rgba(var(--ion-color-secondary-rgb), 0.42);
  background: rgba(var(--ion-color-secondary-rgb), 0.2);
  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-secondary-rgb), 0.24), 0 6px 14px rgba(var(--ion-color-secondary-rgb), 0.14);
}

@media (max-width: 640px) {
  .range-card {
    padding: 0.72rem;
    border-radius: 16px;
  }
  .range-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/select/select-date-range/select-date-range.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,6HAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,uDAAA;EACA,mBAAA;EACA,uDAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AACF;;AAEA;EACE,4CAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,uDAAA;EACA,mBAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,4CAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yDAAA;EACA,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,mBAAA;EACA,uDAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0DAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,0DAAA;EACA,oDAAA;EACA,4BAAA;EACA,6GAAA;AACF;;AAEA;EACE,sDAAA;EACA,oDAAA;AACF;;AAEA;EACE,wDAAA;EACA,sDAAA;AACF;;AAEA;EACE,sDAAA;EACA,mDAAA;EACA,yHAAA;EACA,2BAAA;AACF;;AAEA;EACE,wDAAA;EACA,qDAAA;EACA,6HAAA;AACF;;AAEA;EACE;IACE,gBAAA;IACA,mBAAA;EACF;EAEA;IACE,0BAAA;EAAF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.range-content {\n  --background: linear-gradient(180deg, rgba(var(--ion-color-primary-rgb), 0.04), transparent 18%), var(--ion-background-color);\n}\n\n.range-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.range-card {\n  padding: 0.8rem;\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);\n  border-radius: 18px;\n  background: rgba(var(--ion-background-color-rgb), 0.98);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.range-card__top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.7rem;\n}\n\n.range-card__top h2 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ion-text-color);\n}\n\n.range-card__top small {\n  color: rgba(var(--ion-text-color-rgb), 0.58);\n  font-size: 0.78rem;\n}\n\n.range-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n\n.range-field-card {\n  padding: 0.7rem;\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.07);\n  border-radius: 14px;\n  background: rgba(var(--ion-text-color-rgb), 0.02);\n}\n\n.range-field-card__label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  margin-bottom: 0.45rem;\n}\n\n.range-field-card__label span {\n  color: rgba(var(--ion-text-color-rgb), 0.56);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.range-field-card__label strong {\n  color: var(--ion-text-color);\n  font-size: 0.88rem;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\nion-item.range-field {\n  --background: rgba(var(--ion-background-color-rgb), 0.92);\n  --border-radius: 12px;\n  --inner-padding-end: 0.35rem;\n  --padding-start: 0.65rem;\n  min-height: 2.75rem;\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.08);\n}\n\nion-input.range-input {\n  --padding-top: 0.55rem;\n  --padding-bottom: 0.55rem;\n  --padding-start: 0;\n  --placeholder-color: rgba(var(--ion-text-color-rgb), 0.42);\n  font-size: 0.92rem;\n  font-weight: 600;\n}\n\nion-datetime-button.range-trigger {\n  display: block;\n  margin-top: 0.45rem;\n  min-height: 2.2rem;\n}\n\n.preset-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\nion-chip.preset-chip {\n  margin: 0;\n  min-height: 2rem;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.14);\n  background: rgba(var(--ion-color-primary-rgb), 0.08);\n  color: var(--ion-text-color);\n  transition: background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;\n}\n\nion-chip.preset-chip.preset-chip--primary {\n  border-color: rgba(var(--ion-color-primary-rgb), 0.18);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n\nion-chip.preset-chip.preset-chip--secondary {\n  border-color: rgba(var(--ion-color-secondary-rgb), 0.18);\n  background: rgba(var(--ion-color-secondary-rgb), 0.12);\n}\n\nion-chip.preset-chip.preset-chip--active {\n  border-color: rgba(var(--ion-color-primary-rgb), 0.42);\n  background: rgba(var(--ion-color-primary-rgb), 0.2);\n  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.24), 0 6px 14px rgba(var(--ion-color-primary-rgb), 0.14);\n  transform: translateY(-1px);\n}\n\nion-chip.preset-chip.preset-chip--secondary.preset-chip--active {\n  border-color: rgba(var(--ion-color-secondary-rgb), 0.42);\n  background: rgba(var(--ion-color-secondary-rgb), 0.2);\n  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-secondary-rgb), 0.24), 0 6px 14px rgba(var(--ion-color-secondary-rgb), 0.14);\n}\n\n@media (max-width: 640px) {\n  .range-card {\n    padding: 0.72rem;\n    border-radius: 16px;\n  }\n\n  .range-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
